<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>TFTP</h4>
        <small>Current File: {{ file_path }}</small>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <textarea v-model="server_object.contents" class="form-control" rows="30"></textarea>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-hub-primary" @click="save()">Save</button>
        <router-link :to="{ name: 'AdminMachineTFTPIndex' }" class="btn btn-secondary">Cancel</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'file_path'
  ],
  computed: {
    ...mapGetters({
      server_object: 'singleServerObject'
    })
  },
  created () {
    this.$store.dispatch('getServerObject', this.file_path)
  },
  methods: {
    save () {
      this.$store.dispatch('editServerObject', { file_path: this.file_path, file_contents: this.server_object.contents })
    }
  }
}
</script>

<style scoped>
</style>
